<app-header></app-header>
<div class="mb-[30vh]">
    <div class="carta ml-10 mt-10 mr-10">
        <stdout-card *ngIf="settingFreeUser">
            <stdout-card-header class="card-header">
                <h2>{{"lim_dom"|transloco}}</h2>
            </stdout-card-header>

            <stdout-card-content>
                <div class=" flex justify-between items-center  flex-wrap  ">
                    <div class="w-[333px] m-[1px] ">
                        <stdout-text-input [value]="settingFreeUser.limiteNumeroDomande" class="bordo"
                            placeholder="Inserisci limite quiz" type="text"
                            (change)="changeLimitQuestions($event)"></stdout-text-input>

                    </div>
                    <div class=" mt-[1px] w-[200px]">
                        <stdout-button (click)="saveChanges()" class="bottone-banca" size="large" color="white">
                            <p>{{"salva"|transloco}}</p>
                        </stdout-button>
                    </div>
                </div>
            </stdout-card-content>

        </stdout-card>
    </div>

    <div *ngIf="settingFreeUser" class=" grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
        <div class=" px-10 mt-10 ">
            <div class=" rounded-md w-full bg-white">
                <div class="crt1">
                    <stdout-card>
                        <stdout-card-header>
                            <div (click)="v1()" class="cursor-pointer flex justify-between">{{"attivita"|transloco}}
                                <fa-icon [icon]="showPrima ? faChevronUp : faChevronDown"></fa-icon>
                            </div>
                        </stdout-card-header>
                        <stdout-card-content class *ngIf="showPrima">
                            <div class="pc flex  items-center ">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.apprendimentoLibero"
                                        (change)="changeCheckValue('apprendimentoLibero',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"app_lib"|transloco}}</p>
                                </div>
                            </div>
                            <div class="sc  mt-[20px] flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.apprendimentoGuidato"
                                        (change)="changeCheckValue('apprendimentoGuidato',$event)"></stdout-checkbox>

                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"app_guid"|transloco}}</p>
                                </div>
                            </div>
                            <div class="tc mt-[20px] flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.simulazioneEsame"
                                        (change)="changeCheckValue('simulazioneEsame',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"sim_esa"|transloco}}</p>
                                </div>
                            </div>

                            <div class="flex justify-center bottoni  mt-10 ">
                                <div class="w-[200px] h-[45px] mr-[10px]">
                                    <stdout-button
                                        (click)="settingFreeUser.simulazioneEsame = false;settingFreeUser.apprendimentoGuidato = false;settingFreeUser.apprendimentoLibero = false"
                                        class="btn-bianco" size="large" color="black">
                                        <h2>{{"elimina"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                                <div class="ml-[10px] w-[200px] h-[45px]">
                                    <stdout-button class="btn-blu" (click)="saveChanges()" size="large" color="white">
                                        <h2>{{"salva"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                            </div>
                        </stdout-card-content>
                    </stdout-card>
                </div>
            </div>
        </div>


        <div class=" px-10 mt-10 ">
            <div class="  rounded-md w-full bg-white">
                <div class="crt2 ">
                    <stdout-card>
                        <stdout-card-header>
                            <div (click)="v2()" class="cursor-pointer flex justify-between">{{"ord_quiz"|transloco}}
                                <fa-icon [icon]="showSeconda ? faChevronUp : faChevronDown"></fa-icon>
                            </div>
                        </stdout-card-header>
                        <stdout-card-content class *ngIf="showSeconda">
                            <div class="pc  flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.ordineQuizAlfabetico"
                                        (change)="changeCheckValue('ordineQuizAlfabetico',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"alf"|transloco}}</p>
                                </div>
                            </div>
                            <div class="sc  mt-[20px] flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.ordineQuizCasuale"
                                        (change)="changeCheckValue('ordineQuizCasuale',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"cas"|transloco}}</p>
                                </div>
                            </div>
                            <div class="tc  mt-[20px] flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.ordineQuizUfficiale"
                                        (change)="changeCheckValue('ordineQuizUfficiale',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"uff"|transloco}}</p>
                                </div>
                            </div>

                            <div class="flex justify-center bottoni  mt-10">
                                <div class="w-[200px] h-[45px] mr-[10px]">
                                    <stdout-button
                                        (click)="settingFreeUser.ordineQuizUfficiale = false;settingFreeUser.ordineQuizAlfabetico = false;settingFreeUser.ordineQuizCasuale = false "
                                        class="btn-bianco" size="large" color="black">
                                        <h2>{{"elimina"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                                <div class="ml-[10px] w-[200px] h-[45px]">
                                    <stdout-button class="btn-blu" (click)="saveChanges()" size="large" color="white">
                                        <h2>{{"salva"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                            </div>

                        </stdout-card-content>
                    </stdout-card>
                </div>

            </div>
        </div>


        <div class=" px-10 mt-10 ">
            <div class=" rounded-md w-full bg-white">
                <div class="crt3">
                    <stdout-card>
                        <stdout-card-header>
                            <div (click)="v3()" class="cursor-pointer flex justify-between">{{"filtri"|transloco}}
                                <fa-icon [icon]="showTerza ? faChevronUp : faChevronDown"></fa-icon>
                            </div>
                        </stdout-card-header>
                        <stdout-card-content class *ngIf="showTerza">
                            <div class="pc   flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.filtroSelezioneMateria"
                                        (change)="changeCheckValue('filtroSelezioneMateria',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"sel_mat"|transloco}}</p>
                                </div>
                            </div>
                            <div class="sc  mt-[20px] flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.filtroParolaChiave"
                                        (change)="changeCheckValue('filtroParolaChiave',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"prl_chv"|transloco}}</p>
                                </div>
                            </div>
                            <div class="tc  mt-[20px] flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.filtroIntervalloNumerico"
                                        (change)="changeCheckValue('filtroIntervalloNumerico',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"int_num"|transloco}}</p>
                                </div>
                            </div>
                            <div class="qc  mt-[20px] flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.filtroDifficoltaQuiz"
                                        (change)="changeCheckValue('filtroDifficoltaQuiz',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"dif_quiz"|transloco}}</p>
                                </div>
                            </div>
                            <div class="qqc  mt-[20px] flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.filtroQuizConSpiegazione"
                                        (change)="changeCheckValue('filtroQuizConSpiegazione',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"quiz_con_spieg"|transloco}}</p>
                                </div>
                            </div>
                            <div class="sc  mt-[20px] flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.filtroQuizConImmagini"
                                        (change)="changeCheckValue('filtroQuizConImmagini',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"quiz_con_img"|transloco}}</p>
                                </div>
                            </div>

                            <div class="flex justify-center bottoni  mt-10">
                                <div class="w-[200px] h-[45px] mr-[10px]">
                                    <stdout-button
                                        (click)="settingFreeUser.filtroQuizConImmagini = null;settingFreeUser.filtroQuizConSpiegazione= false;settingFreeUser.filtroDifficoltaQuiz = false;settingFreeUser.filtroIntervalloNumerico = false;settingFreeUser.filtroParolaChiave = false;settingFreeUser.filtroSelezioneMateria = false"
                                        class="btn-bianco" size="large" color="black">
                                        <h2>{{"elimina"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                                <div class="ml-[10px] w-[200px] h-[45px]">
                                    <stdout-button class="btn-blu" (click)="saveChanges()" size="large" color="white">
                                        <h2>{{"salva"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                            </div>
                        </stdout-card-content>
                    </stdout-card>
                </div>
            </div>
        </div>
        <div class=" px-10 mt-10">
            <div class="  rounded-md w-full bg-white">
                <div class="crt4">
                    <stdout-card>
                        <stdout-card-header>
                            <div (click)="v4()" class="cursor-pointer flex justify-between">{{"svlg_quiz"|transloco}}
                                <fa-icon [icon]="showQuarta ? faChevronUp : faChevronDown"></fa-icon>
                            </div>
                        </stdout-card-header>
                        <stdout-card-content class *ngIf="showQuarta">
                            <div class="grid grid-cols-1 md:grid-cols-2 ">
                                <!-- Elemento 1 -->
                                <div class=" ">
                                    <div class="pc   flex items-center">
                                        <div class="fix-check-funz">
                                            <stdout-checkbox [value]="settingFreeUser.svolgiQuizTutti"
                                                (change)="changeCheckValue('svolgiQuizTutti',$event)"></stdout-checkbox>
                                        </div>
                                        <div class="ml-[10px]">
                                            <p>{{"tutti"|transloco}}</p>
                                        </div>
                                    </div>
                                    <div class="sc mt-[20px]  flex items-center">
                                        <div class="fix-check-funz">
                                            <stdout-checkbox [value]="settingFreeUser.svolgiQuizSvolti"
                                                (change)="changeCheckValue('svolgiQuizSvolti',$event)"></stdout-checkbox>
                                        </div>
                                        <div class="ml-[10px]">
                                            <p>{{"svolti"|transloco}}</p>
                                        </div>
                                    </div>
                                    <div class="tc mt-[20px]  flex items-center">
                                        <div class="fix-check-funz">
                                            <stdout-checkbox [value]="settingFreeUser.svolgiQuizSospesi"
                                                (change)="changeCheckValue('svolgiQuizSospesi',$event)"></stdout-checkbox>
                                        </div>
                                        <div class="ml-[10px]">
                                            <p>{{"sospesi"|transloco}}</p>
                                        </div>
                                    </div>
                                    <div class="qc mt-[20px]  flex items-center">
                                        <div class="fix-check-funz">
                                            <stdout-checkbox [value]="settingFreeUser.svolgiQuizSalvati"
                                                (change)="changeCheckValue('svolgiQuizSalvati',$event)"></stdout-checkbox>
                                        </div>
                                        <div class="ml-[10px]">
                                            <p>{{"salvati"|transloco}}</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Elemento 2 -->
                                <div class="">
                                    <div class="qqc  flex items-center">
                                        <div class="fix-check-funz">
                                            <stdout-checkbox [value]="settingFreeUser.svolgiQuizNuovi"
                                                (change)="changeCheckValue('svolgiQuizNuovi',$event)"></stdout-checkbox>
                                        </div>
                                        <div class="ml-[10px]">
                                            <p>{{"nuovi"|transloco}}</p>
                                        </div>
                                    </div>
                                    <div class="sc mt-[20px]  flex items-center">
                                        <div class="fix-check-funz">
                                            <stdout-checkbox [value]="settingFreeUser.svolgiQuizErrati"
                                                (change)="changeCheckValue('svolgiQuizErrati',$event)"></stdout-checkbox>
                                        </div>
                                        <div class="ml-[10px]">
                                            <p>{{"errati"|transloco}}</p>
                                        </div>
                                    </div>
                                    <div class="se mt-[20px]  flex items-center">
                                        <div class="fix-check-funz">
                                            <stdout-checkbox [value]="settingFreeUser.svolgiQuizCorretti"
                                                (change)="changeCheckValue('svolgiQuizCorretti',$event)"></stdout-checkbox>
                                        </div>
                                        <div class="ml-[10px]">
                                            <p>{{"corretti"|transloco}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>






                            <div class="flex justify-center bottoni  mt-10">
                                <div class="w-[200px] h-[45px] mr-[10px]">
                                    <stdout-button
                                        (click)="settingFreeUser.svolgiQuizSalvati = false;settingFreeUser.svolgiQuizCorretti = false;settingFreeUser.svolgiQuizSospesi = false;settingFreeUser.svolgiQuizErrati = false;settingFreeUser.svolgiQuizSvolti =false;settingFreeUser.svolgiQuizNuovi = false;settingFreeUser.svolgiQuizTutti = false"
                                        class="btn-bianco" size="large" color="black">
                                        <h2>{{"elimina"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                                <div class="ml-[10px] w-[200px] h-[45px]">
                                    <stdout-button class="btn-blu" (click)="saveChanges()" size="large" color="white">
                                        <h2>{{"salva"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                            </div>
                        </stdout-card-content>
                    </stdout-card>
                </div>
            </div>
        </div>
        <div class=" px-10 mt-10 ">
            <div class="  rounded-md w-full bg-white">
                <div class="crt5 ">
                    <stdout-card>
                        <stdout-card-header>
                            <div (click)="v5()" class="cursor-pointer flex justify-between">{{"opzioni"|transloco}}
                                <fa-icon [icon]="showQuinta ? faChevronUp : faChevronDown"></fa-icon>
                            </div>
                        </stdout-card-header>
                        <stdout-card-content class *ngIf="showQuinta">
                            <div class="pc   flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.opzioneMostraRispostaCorrette"
                                        (change)="changeCheckValue('opzioneMostraRispostaCorrette',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"ms_corr"|transloco}}</p>
                                </div>
                            </div>
                            <div class="sc mt-[20px]  flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.opzioneContatoreRisposteCorretteErrate"
                                        (change)="changeCheckValue('opzioneContatoreRisposteCorretteErrate',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"ms_cont"|transloco}}</p>
                                </div>
                            </div>
                            <div class="tc mt-[20px]  flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.opzioneAutonext"
                                        (change)="changeCheckValue('opzioneAutonext',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"ab_atxt"|transloco}}</p>
                                </div>
                            </div>

                            <div class="flex justify-center bottoni  mt-10">
                                <div class="w-[200px] h-[45px] mr-[10px]">
                                    <stdout-button
                                        (click)="settingFreeUser.opzioneAutonext = false;settingFreeUser.opzioneContatoreRisposteCorretteErrate = false;settingFreeUser.opzioneMostraRispostaCorrette = false  "
                                        class="btn-bianco" size="large" color="black">
                                        <h2>{{"elimina"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                                <div class="ml-[10px] w-[200px] h-[45px]">
                                    <stdout-button class="btn-blu" (click)="saveChanges()" size="large" color="white">
                                        <h2>{{"salva"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                            </div>
                        </stdout-card-content>
                    </stdout-card>
                </div>
            </div>
        </div>
        <div class="px-10 mt-10">
            <div class="  rounded-md w-full bg-white">
                <div class="crt6 ">
                    <stdout-card>
                        <stdout-card-header>
                            <div (click)="v6()" class="cursor-pointer flex justify-between">{{"mod_stampa"|transloco}}
                                <fa-icon [icon]="showSesta ? faChevronUp : faChevronDown"></fa-icon>
                            </div>
                        </stdout-card-header>
                        <stdout-card-content class *ngIf="showSesta">
                            <div class="pc   flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.stampaQuizConCorrettoreSeparato"
                                        (change)="changeCheckValue('stampaQuizConCorrettoreSeparato',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"stampa_sep"|transloco}}</p>
                                </div>
                            </div>
                            <div class="sc mt-[20px]  flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.stampaQuizConCorrettoreAlFianco"
                                        (change)="changeCheckValue('stampaQuizConCorrettoreAlFianco',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"stampa_aff"|transloco}}</p>
                                </div>
                            </div>
                            <div class="tc mt-[20px]  flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.stampaQuizConLaSoloRispostaCorretta"
                                        (change)="changeCheckValue('stampaQuizConLaSoloRispostaCorretta',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"stampa_corr"|transloco}}</p>
                                </div>
                            </div>

                            <div class="flex justify-center  bottoni mt-10 ">
                                <div class="w-[200px] h-[45px] mr-[10px]">
                                    <stdout-button
                                        (click)="settingFreeUser.stampaQuizConLaSoloRispostaCorretta = false; settingFreeUser.stampaQuizConCorrettoreAlFianco = false;settingFreeUser.stampaQuizConCorrettoreSeparato = false"
                                        class="btn-bianco" size="large" color="black">
                                        <h2>{{"elimina"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                                <div class="ml-[10px] w-[200px] h-[45px]">
                                    <stdout-button class="btn-blu" (click)="saveChanges()" size="large" color="white">
                                        <h2>{{"salva"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                            </div>
                        </stdout-card-content>
                    </stdout-card>
                </div>
            </div>
        </div>

        <div class="px-10 mt-10 ">
            <div class="  rounded-md w-full bg-white">
                <div class="crt7">
                    <stdout-card>
                        <stdout-card-header>
                            <div (click)="v7()" class="cursor-pointer flex justify-between">{{"opzioni_ese"|transloco}}
                                <fa-icon [icon]="showSettima ? faChevronUp : faChevronDown"></fa-icon>
                            </div>
                        </stdout-card-header>
                        <stdout-card-content class *ngIf="showSettima">
                            <div class="pc   flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.opzioneEsercitazioneInfoSullaDomanda"
                                        (change)="changeCheckValue('opzioneEsercitazioneInfoSullaDomanda',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"info_dom"|transloco}}</p>
                                </div>
                            </div>
                            <div class="sc mt-[20px]  flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.opzioneEsercitazioneTesto"
                                        (change)="changeCheckValue('opzioneEsercitazioneTesto',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"testo"|transloco}}</p>
                                </div>
                            </div>
                            <div class="tc mt-[20px]  flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.opzioneEsercitazioneSalvaDomanda"
                                        (change)="changeCheckValue('opzioneEsercitazioneSalvaDomanda',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"salva_dom"|transloco}}</p>
                                </div>
                            </div>
                            <div class="qc mt-[20px]  flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.opzioneEsercitazioneCondividi"
                                        (change)="changeCheckValue('opzioneEsercitazioneCondividi',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"condividi"|transloco}}</p>
                                </div>
                            </div>

                            <div class="flex justify-center  bottoni mt-10">
                                <div class="w-[200px] h-[45px] mr-[10px]">
                                    <stdout-button
                                        (click)="settingFreeUser.opzioneEsercitazioneCondividi=false;settingFreeUser.opzioneEsercitazioneSalvaDomanda=false;settingFreeUser.opzioneEsercitazioneTesto=false;settingFreeUser.opzioneEsercitazioneInfoSullaDomanda=false"
                                        class="btn-bianco" size="large" color="black">
                                        <h2>{{"elimina"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                                <div class="ml-[10px] w-[200px] h-[45px]">
                                    <stdout-button class="btn-blu" (click)="saveChanges()" size="large" color="white">
                                        <h2>{{"salva"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                            </div>
                        </stdout-card-content>
                    </stdout-card>
                </div>

            </div>
        </div>

        <div class="px-10 mt-10 ">
            <div class="  rounded-md w-full bg-white">
                <div class="crt8">
                    <stdout-card>
                        <stdout-card-header>
                            <div (click)="v8()" class="cursor-pointer flex justify-between">{{"altro"|transloco}}
                                <fa-icon [icon]="showOttava ? faChevronUp : faChevronDown"></fa-icon>
                            </div>
                        </stdout-card-header>
                        <stdout-card-content class *ngIf="showOttava">
                            <div class="pc   flex items-center">
                                <div class="fix-check-funz">
                                    <stdout-checkbox [value]="settingFreeUser.storico"
                                        (change)="changeCheckValue('storico',$event)"></stdout-checkbox>
                                </div>
                                <div class="ml-[10px]">
                                    <p>{{"storico"|transloco}}</p>
                                </div>
                            </div>

                            <div class="flex justify-center  bottoni mt-10">
                                <div class="w-[200px] h-[45px] mr-[10px]">
                                    <stdout-button (click)="settingFreeUser.storico=false;" class="btn-bianco"
                                        size="large" color="black">
                                        <h2>{{"elimina"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                                <div class="ml-[10px] w-[200px] h-[45px]">
                                    <stdout-button class="btn-blu" (click)="saveChanges()" size="large" color="white">
                                        <h2>{{"salva"|transloco}}</h2>
                                    </stdout-button>
                                </div>
                            </div>
                        </stdout-card-content>
                    </stdout-card>
                </div>

            </div>
        </div>
    </div>


</div>